import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import ContentClear from 'material-ui/svg-icons/image/adjust';
import FuseTheme from '../global/theme';

const styles = {
    buttonContainer: {
        margin: '0 0 1em 16px'
    },
    fieldDescription: {
        flex: '1 1 40%',
        display: 'block',
        width: 'auto',
        height: '2em',
        fontSize: '12px',
        color: FuseTheme.palette.lightTextColor,
    },
};

const AdjustLocationInventory = ({basePath = '', record = {}, instructions = '', label = '', locationId = ''}) => (
    <div style={styles.buttonContainer}>
        <span style={styles.fieldDescription}>{instructions}</span>
        <RaisedButton
            primary
            label={label}
            icon={<ContentClear/>}
            containerElement={<Link to={`${basePath}/${locationId}`}/>}
        />
    </div>
);

AdjustLocationInventory.propTypes = {
    basePath: PropTypes.string,
    filterValues: PropTypes.object,
    instructions: PropTypes.string,
    locationId: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.object,
};

AdjustLocationInventory.defaultProps = {
    style: {padding: 0},
};

export default AdjustLocationInventory;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/AdjustLocationInventoryButton.js